export interface Project {
  id: number;
  title: string;
  title_en?: string;
  location: string;
  location_en?: string;
  category: string;
  tag: string;
  tag_en?: string;
  year: string;
  client: string;
  client_en?: string;
  description: string;
  description_en?: string;
  image: string;
  featured: boolean;
  slug: string;
  folder: string;
  gallery: string[];
}

const BASE_URL = 'https://okayisu.com/common/img/projeler';

export const allProjects: Project[] = [
  {
    id: 1,
    title: 'Anthill Residence',
    title_en: 'Anthill Residence',
    location: 'İstanbul, Türkiye',
    location_en: 'Istanbul, Türkiye',
    category: 'Konut & Rezidans',
    tag: 'Rezidans',
    tag_en: 'Residence',
    year: '2015',
    client: 'Ant Yapı',
    client_en: 'Ant Yapı',
    description: 'İstanbul\'un prestijli rezidans projesi Anthill Residence için kapsamlı LED aydınlatma çözümleri.',
    description_en: 'Comprehensive LED lighting solutions for Anthill Residence, one of Istanbul\'s most prestigious residential projects.',
    image: `${BASE_URL}/ANTHILL-RESIDENCE/anthill-kapak.jpg`,
    featured: true,
    slug: 'anthill-residence',
    folder: 'ANTHILL-RESIDENCE',
    gallery: [
      `${BASE_URL}/ANTHILL-RESIDENCE/anthill-kapak.jpg`,
      `${BASE_URL}/ANTHILL-RESIDENCE/_MG_6453.jpg`,
    ],
  },
  {
    id: 2,
    title: 'Aqua Mall AVM',
    title_en: 'Aqua Mall',
    location: 'Rusya',
    location_en: 'Russia',
    category: 'Ticari & AVM',
    tag: 'Alışveriş Merkezi',
    tag_en: 'Shopping Mall',
    year: '2022',
    client: 'Aquamall Group',
    client_en: 'Aquamall Group',
    description: 'Aqua Mall Alışveriş Merkezi için iç ve dış mekan LED aydınlatma tasarımı ve uygulaması.',
    description_en: 'Indoor and outdoor LED lighting design and implementation for Aqua Mall Shopping Center.',
    image: `${BASE_URL}/AQUAMALL-AVM/aqumall-kapak.jpg`,
    featured: true,
    slug: 'aqua-mall-avm',
    folder: 'AQUAMALL-AVM',
    gallery: [
      `${BASE_URL}/AQUAMALL-AVM/aqumall-kapak.jpg`,
      `${BASE_URL}/AQUAMALL-AVM/aqumall2.jpg`,
    ],
  },
  {
    id: 3,
    title: 'Aşgabat Havalimanı',
    title_en: 'Ashgabat Airport',
    location: 'Aşgabat, Türkmenistan',
    location_en: 'Ashgabat, Turkmenistan',
    category: 'Altyapı & Ulaşım',
    tag: 'Uluslararası',
    tag_en: 'International',
    year: '2016',
    client: 'Turkmen Group',
    client_en: 'Turkmen Group',
    description: 'Türkmenistan Aşgabat Uluslararası Havalimanı için özel LED aydınlatma projesi.',
    description_en: 'Custom LED lighting project for Ashgabat International Airport in Turkmenistan.',
    image: `${BASE_URL}/ASGABAT-HAVALIMANI/asgabat-kapak.jpg`,
    featured: true,
    slug: 'asgabat-havalimani',
    folder: 'ASGABAT-HAVALIMANI',
    gallery: [
      `${BASE_URL}/ASGABAT-HAVALIMANI/asgabat-kapak.jpg`,
      `${BASE_URL}/ASGABAT-HAVALIMANI/asgabat1.jpg`,
      `${BASE_URL}/ASGABAT-HAVALIMANI/asgabat2.jpg`,
    ],
  },
  {
    id: 4,
    title: 'Avrasya Tüneli',
    title_en: 'Eurasia Tunnel',
    location: 'İstanbul, Türkiye',
    location_en: 'Istanbul, Türkiye',
    category: 'Altyapı & Ulaşım',
    tag: 'Mega Proje',
    tag_en: 'Mega Project',
    year: '2016',
    client: 'Kitoko Group',
    client_en: 'Kitoko Group',
    description: 'Avrasya Tüneli için özel DMX LED aydınlatma projesi.',
    description_en: 'A custom DMX LED lighting project for the Eurasia Tunnel.',
    image: `${BASE_URL}/AVRASYA-TUNELI/avrasya-tuneli-kapak.jpg`,
    featured: true,
    slug: 'avrasya-tuneli',
    folder: 'AVRASYA-TUNELI',
    gallery: [
      `${BASE_URL}/AVRASYA-TUNELI/avrasya-tuneli-kapak.jpg`,
      `${BASE_URL}/AVRASYA-TUNELI/Avrasya-Tuneli-13.jpg`,
      `${BASE_URL}/AVRASYA-TUNELI/Avrasya-Tuneli-4.jpg`,
      `${BASE_URL}/AVRASYA-TUNELI/Avrasya-Tuneli-7.jpg`,
      `${BASE_URL}/AVRASYA-TUNELI/Avrasya-Tuneli-8.jpg`,
    ],
  },
  {
    id: 5,
    title: 'Barbaros Hayrettin Paşa Camii',
    title_en: 'Barbaros Hayrettin Pasha Mosque',
    location: 'İstanbul, Türkiye',
    location_en: 'Istanbul, Türkiye',
    category: 'Kamu & Kültürel',
    tag: 'Dini Yapı',
    tag_en: 'Religious Building',
    year: '2019',
    client: 'Asl İnşaat',
    client_en: 'Asl İnşaat',
    description: 'Barbaros Hayrettin Paşa Camii için özel mimari LED aydınlatma tasarımı ve uygulaması.',
    description_en: 'Custom architectural LED lighting design and implementation for Barbaros Hayrettin Pasha Mosque.',
    image: `${BASE_URL}/BARBOROS-HAYRETTIN-PASA-CAMI/cami-kapak.jpg`,
    featured: true,
    slug: 'barbaros-hayrettin-pasa-camii',
    folder: 'BARBOROS-HAYRETTIN-PASA-CAMI',
    gallery: [
      `${BASE_URL}/BARBOROS-HAYRETTIN-PASA-CAMI/cami-kapak.jpg`,
      `${BASE_URL}/BARBOROS-HAYRETTIN-PASA-CAMI/bhp-cami-kopyasi.jpg`,
    ],
  },
  {
    id: 6,
    title: 'İstanbul Akvaryum',
    title_en: 'İstanbul Aquarium',
    location: 'İstanbul, Türkiye',
    location_en: 'Istanbul, Türkiye',
    category: 'Ticari & AVM',
    tag: 'Alışveriş Merkezi',
    tag_en: 'Shopping Mall',
    year: '2015',
    client: 'Nuh İnşaat',
    client_en: 'Nuh İnşaat',
    description: 'İstanbul Akvaryum için iç mekan ve sergi alanları LED aydınlatma projesi.',
    description_en: 'Interior and exhibition area LED lighting project for İstanbul Aquarium.',
    image: `${BASE_URL}/FLORYA-AKVARYUM/ist-akvaryum-kapak.jpg`,
    featured: true,
    slug: 'florya-akvaryum',
    folder: 'FLORYA-AKVARYUM',
    gallery: [
      `${BASE_URL}/FLORYA-AKVARYUM/ist-akvaryum-kapak.jpg`,
      `${BASE_URL}/FLORYA-AKVARYUM/_MG_6125.jpg`,
      `${BASE_URL}/FLORYA-AKVARYUM/_MG_6234.jpg`,
      `${BASE_URL}/FLORYA-AKVARYUM/_MG_6263.jpg`,
      `${BASE_URL}/FLORYA-AKVARYUM/_MG_6283.jpg`,
      `${BASE_URL}/FLORYA-AKVARYUM/_MG_6312.jpg`,
      `${BASE_URL}/FLORYA-AKVARYUM/istanbul-akvaryum.jpg`,
    ],
  },
  {
    id: 7,
    title: 'Hilton Adana',
    title_en: 'Hilton Adana',
    location: 'Adana, Türkiye',
    location_en: 'Adana, Türkiye',
    category: 'Otel & Konaklama',
    tag: 'Lüks Otel',
    tag_en: 'Luxury Hotel',
    year: '2017',
    client: 'Sabancı Group',
    client_en: 'Sabancı Group',
    description: 'Hilton Adana otelinin iç mekan, lobi ve dış cephe LED aydınlatma dönüşüm projesi.',
    description_en: 'Interior, lobby, and facade LED lighting transformation project for Hilton Adana.',
    image: `${BASE_URL}/HILTON-ADANA/hilton-adana-kapak.jpg`,
    featured: true,
    slug: 'hilton-adana',
    folder: 'HILTON-ADANA',
    gallery: [
      `${BASE_URL}/HILTON-ADANA/hilton-adana-kapak.jpg`,
      `${BASE_URL}/HILTON-ADANA/Riverside2.jpg`,
      `${BASE_URL}/HILTON-ADANA/Riverside4.jpg`,
      `${BASE_URL}/HILTON-ADANA/Riverside5.jpg`,
    ],
  },
  {
    id: 8,
    title: 'İstanbul Finans Merkezi',
    title_en: 'Istanbul Financial Center',
    location: 'İstanbul, Türkiye',
    location_en: 'Istanbul, Türkiye',
    category: 'Kurumsal & Ticari',
    tag: 'Finans',
    tag_en: 'Finance',
    year: '2019',
    client: 'Gül & Yapı Yapı İnşaat',
    client_en: 'Gül & Yapı Yapı İnşaat',
    description: 'İstanbul Finans Merkezi kuleleri için kurumsal LED aydınlatma ve akıllı kontrol sistemleri.',
    description_en: 'Corporate LED lighting and smart control systems for Istanbul Financial Center towers.',
    image: `${BASE_URL}/ISTANBUL-FINANS-MERKEZI/ifm-kapak.jpg`,
    featured: true,
    slug: 'istanbul-finans-merkezi',
    folder: 'ISTANBUL-FINANS-MERKEZI',
    gallery: [
      `${BASE_URL}/ISTANBUL-FINANS-MERKEZI/ifm-kapak.jpg`,
      `${BASE_URL}/ISTANBUL-FINANS-MERKEZI/ifm.jpg`,
    ],
  },
  {
    id: 9,
    title: 'Kayseri Kadir Has Stadyumu',
    title_en: 'Kayseri Kadir Has Stadium',
    location: 'Kayseri, Türkiye',
    location_en: 'Kayseri, Türkiye',
    category: 'Spor & Eğlence',
    tag: 'Stadyum',
    tag_en: 'Stadium',
    year: '2018',
    client: 'Kayseri Büyükşehir Belediyesi',
    client_en: 'Kayseri Metropolitan Municipality',
    description: 'Kayseri Kadir Has Stadyumu için saha aydınlatması ve tribün LED uygulamaları.',
    description_en: 'Field lighting and grandstand LED applications for Kayseri Kadir Has Stadium.',
    image: `${BASE_URL}/KAYSERI-KADIR-HAS-STADYUMU/stadyum-kapak.jpg`,
    featured: true,
    slug: 'kayseri-kadir-has-stadyumu',
    folder: 'KAYSERI-KADIR-HAS-STADYUMU',
    gallery: [
      `${BASE_URL}/KAYSERI-KADIR-HAS-STADYUMU/stadyum-kapak.jpg`,
      `${BASE_URL}/KAYSERI-KADIR-HAS-STADYUMU/IMG_3652_resize.jpg`,
      `${BASE_URL}/KAYSERI-KADIR-HAS-STADYUMU/IMG_3694_resize.jpg`,
      `${BASE_URL}/KAYSERI-KADIR-HAS-STADYUMU/IMG_3803_resize.jpg`,
      `${BASE_URL}/KAYSERI-KADIR-HAS-STADYUMU/IMG_3838_resize.jpg`,
      `${BASE_URL}/KAYSERI-KADIR-HAS-STADYUMU/kayseri10.jpg`,
      `${BASE_URL}/KAYSERI-KADIR-HAS-STADYUMU/kayseri2.jpg`,
      `${BASE_URL}/KAYSERI-KADIR-HAS-STADYUMU/kayseri3.jpg`,
    ],
  },
  {
    id: 10,
    title: 'Le Méridien Otel',
    title_en: 'Le Méridien Hotel',
    location: 'İstanbul, Türkiye',
    location_en: 'Istanbul, Türkiye',
    category: 'Otel & Konaklama',
    tag: 'Lüks Otel',
    tag_en: 'Luxury Hotel',
    year: '2016',
    client: 'Makyol İnşaat',
    client_en: 'Makyol İnşaat',
    description: 'Le Méridien İstanbul için genel aydınlatma ve LED dönüşüm projesi.',
    description_en: 'General lighting and LED transformation project for Le Méridien Istanbul.',
    image: `${BASE_URL}/LE-MERIDIEN-OTEL/lemeridien-kapak.jpg`,
    featured: true,
    slug: 'le-meridien-otel',
    folder: 'LE-MERIDIEN-OTEL',
    gallery: [
      `${BASE_URL}/LE-MERIDIEN-OTEL/lemeridien-kapak.jpg`,
      `${BASE_URL}/LE-MERIDIEN-OTEL/merid.jpg`,
      `${BASE_URL}/LE-MERIDIEN-OTEL/sayfa4.jpg`,
      `${BASE_URL}/LE-MERIDIEN-OTEL/sayfa5-1.jpg`,
      `${BASE_URL}/LE-MERIDIEN-OTEL/sayfa5-3.jpg`,
      `${BASE_URL}/LE-MERIDIEN-OTEL/sayfa7-3.jpg`,
    ],
  },
  {
    id: 11,
    title: 'Rixos Al Nasr Otel',
    title_en: 'Rixos Al Nasr Hotel',
    location: 'Libya',
    location_en: 'Libya',
    category: 'Otel & Konaklama',
    tag: 'Uluslararası',
    tag_en: 'International',
    year: '2010',
    client: 'Kitoko Group',
    client_en: 'Kitoko Group',
    description: 'Rixos Al Nasr Otel için kapsamlı LED aydınlatma ve akıllı kontrol sistemleri.',
    description_en: 'Comprehensive LED lighting and smart control systems for Rixos Al Nasr Hotel.',
    image: `${BASE_URL}/RIXOS-AL-NASR-OTEL/rixos-otel-kapak.jpg`,
    featured: true,
    slug: 'rixos-al-nasr-otel',
    folder: 'RIXOS-AL-NASR-OTEL',
    gallery: [
      `${BASE_URL}/RIXOS-AL-NASR-OTEL/rixos-otel-kapak.jpg`,
      `${BASE_URL}/RIXOS-AL-NASR-OTEL/NASR-RIXOS-HOTEL-16.jpg`,
      `${BASE_URL}/RIXOS-AL-NASR-OTEL/NASR-RIXOS-HOTEL-6.jpg`,
      `${BASE_URL}/RIXOS-AL-NASR-OTEL/NASR-RIXOS-HOTEL-80.jpg`,
    ],
  },
  {
    id: 12,
    title: 'SOCAR',
    title_en: 'SOCAR',
    location: 'İstanbul, Türkiye',
    location_en: 'Istanbul, Türkiye',
    category: 'Kurumsal & Ticari',
    tag: 'Kurumsal',
    tag_en: 'Corporate',
    year: '2017',
    client: 'Artaş İnşaat',
    client_en: 'Artaş İnşaat',
    description: 'SOCAR kurumsal merkezi için endüstriyel ve ofis LED aydınlatma projesi.',
    description_en: 'Industrial and office LED lighting project for SOCAR corporate headquarters.',
    image: `${BASE_URL}/SOCAR/socar-kapak.jpg`,
    featured: true,
    slug: 'socar',
    folder: 'SOCAR',
    gallery: [
      `${BASE_URL}/SOCAR/socar-kapak.jpg`,
      `${BASE_URL}/SOCAR/sayfa9-2.jpg`,
      `${BASE_URL}/SOCAR/sayfa9-4.jpg`,
    ],
  },
  {
    id: 13,
    title: 'The İstanbul Edition Otel',
    title_en: 'The Istanbul Edition Hotel',
    location: 'İstanbul, Türkiye',
    location_en: 'Istanbul, Türkiye',
    category: 'Otel & Konaklama',
    tag: 'Lüks Otel',
    tag_en: 'Luxury Hotel',
    year: '2011',
    client: 'Palmalı Group',
    client_en: 'Palmalı Group',
    description: 'The İstanbul Edition Otel için lüks konaklama LED aydınlatma tasarımı ve uygulaması.',
    description_en: 'Luxury hospitality LED lighting design and implementation for The Istanbul Edition Hotel.',
    image: `${BASE_URL}/THE-ISTANBUL-EDITION-OTEL/edition-otel-kapak.jpg`,
    featured: true,
    slug: 'the-istanbul-edition-otel',
    folder: 'THE-ISTANBUL-EDITION-OTEL',
    gallery: [
      `${BASE_URL}/THE-ISTANBUL-EDITION-OTEL/edition-otel-kapak.jpg`,
      `${BASE_URL}/THE-ISTANBUL-EDITION-OTEL/_MG_6001.jpg`,
      `${BASE_URL}/THE-ISTANBUL-EDITION-OTEL/_MG_6026.jpg`,
      `${BASE_URL}/THE-ISTANBUL-EDITION-OTEL/_MG_6027.jpg`,
      `${BASE_URL}/THE-ISTANBUL-EDITION-OTEL/_MG_6459.jpg`,
      `${BASE_URL}/THE-ISTANBUL-EDITION-OTEL/_MG_6506.jpg`,
      `${BASE_URL}/THE-ISTANBUL-EDITION-OTEL/DSC_0209.jpg`,
      `${BASE_URL}/THE-ISTANBUL-EDITION-OTEL/DSC_0248.jpg`,
      `${BASE_URL}/THE-ISTANBUL-EDITION-OTEL/sayfa12-1.jpg`,
      `${BASE_URL}/THE-ISTANBUL-EDITION-OTEL/sayfa12.jpg`,
      `${BASE_URL}/THE-ISTANBUL-EDITION-OTEL/sayfa13-3.jpg`,
      `${BASE_URL}/THE-ISTANBUL-EDITION-OTEL/sayfa15-4.jpg`,
    ],
  },
  {
    id: 14,
    title: 'Vadi İstanbul AVM',
    title_en: 'Vadi Istanbul Mall',
    location: 'İstanbul, Türkiye',
    location_en: 'Istanbul, Türkiye',
    category: 'Ticari & AVM',
    tag: 'Alışveriş Merkezi',
    tag_en: 'Shopping Mall',
    year: '2015',
    client: 'Artaş İnşaat',
    client_en: 'Artaş İnşaat',
    description: 'Vadi İstanbul Alışveriş Merkezi ve ofisler için kapsamlı iç ve dış mekan LED aydınlatma projesi.',
    description_en: 'Comprehensive indoor and outdoor LED lighting project for Vadi Istanbul Shopping Mall and its offices.',
    image: `${BASE_URL}/VADI-ISTANBUL-AVM/vadi-istanbul-kapak.jpg`,
    featured: true,
    slug: 'vadi-istanbul-avm',
    folder: 'VADI-ISTANBUL-AVM',
    gallery: [
      `${BASE_URL}/VADI-ISTANBUL-AVM/vadi-istanbul-kapak.jpg`,
      `${BASE_URL}/VADI-ISTANBUL-AVM/JNDG4253.jpg`,
      `${BASE_URL}/VADI-ISTANBUL-AVM/NGJD4177.jpg`,
      `${BASE_URL}/VADI-ISTANBUL-AVM/sayfa7-3.jpg`,
      `${BASE_URL}/VADI-ISTANBUL-AVM/sayfa7-4.jpg`,
      `${BASE_URL}/VADI-ISTANBUL-AVM/vadi-istanbul-promax-yapi_05.jpg`,
      `${BASE_URL}/VADI-ISTANBUL-AVM/vadi-istanbul-promax-yapi_14.jpg`,
      `${BASE_URL}/VADI-ISTANBUL-AVM/vadi-istanbul-promax-yapi_23.jpg`,
    ],
  },
  {
    id: 15,
    title: 'Wyndham Grand Otel',
    title_en: 'Wyndham Grand Hotel',
    location: 'Gürcistan',
    location_en: 'Georgia',
    category: 'Otel & Konaklama',
    tag: 'Lüks Otel',
    tag_en: 'Luxury Hotel',
    year: '2018',
    client: 'Novoros Metal',
    client_en: 'Novoros Metal',
    description: 'Wyndham Grand için iç ve dış aydınlatma çözümleri. 10.000 adet DMX pixel dış cephe uygulaması.',
    description_en: 'Interior and exterior lighting solutions for Wyndham Grand, including a 10,000-unit DMX pixel facade installation.',
    image: `${BASE_URL}/WYNDHAM-GRAND-OTEL/wyndham-kapak.jpg`,
    featured: true,
    slug: 'wyndham-grand-otel',
    folder: 'WYNDHAM-GRAND-OTEL',
    gallery: [
      `${BASE_URL}/WYNDHAM-GRAND-OTEL/wyndham-kapak.jpg`,
      `${BASE_URL}/WYNDHAM-GRAND-OTEL/FKMM1504.jpg`,
      `${BASE_URL}/WYNDHAM-GRAND-OTEL/IMG_1945.jpg`,
      `${BASE_URL}/WYNDHAM-GRAND-OTEL/IMG_2113.jpg`,
    ],
  },
  {
    id: 16,
    title: 'Haydarpaşa Numune Hastanesi',
    title_en: 'Haydarpaşa Numune Hospital',
    location: 'İstanbul, Türkiye',
    location_en: 'Istanbul, Türkiye',
    category: 'Kamu & Kültürel',
    tag: 'Hastane',
    tag_en: 'Hospital',
    year: '2011',
    client: 'Atlas İnşaat',
    client_en: 'Atlas Construction',
    description: 'Haydarpaşa Numune Hastanesi genel aydınlatma projesi kapsamında tüm iç mekan aydınlatma çözümleri.',
    description_en: 'Complete interior lighting solutions delivered within the scope of the general lighting project for Haydarpaşa Numune Hospital.',
    image: `${BASE_URL}/HAYDARPASA-NUMUNE-HASTANESI/haydarpasa-numune.jpg`,
    featured: true,
    slug: 'haydarpasa-numune-hastanesi',
    folder: 'HAYDARPASA-NUMUNE-HASTANESI',
    gallery: [
      `${BASE_URL}/HAYDARPASA-NUMUNE-HASTANESI/haydarpasa-numune.jpg`,
    ],
  },
  {
    id: 17,
    title: 'TAI İleri Teknoloji Üretim Tesisi',
    title_en: 'TAI Advanced Technology Production Facility',
    location: 'Ankara, Türkiye',
    location_en: 'Ankara, Türkiye',
    category: 'Endüstriyel & Kurumsal',
    tag: 'Havacılık',
    tag_en: 'Aerospace',
    year: '2010',
    client: 'TAI',
    client_en: 'TAI',
    description: 'TAI İleri Teknoloji Üretim Tesisi için endüstriyel genel aydınlatma çözümleri.',
    description_en: 'Industrial general lighting solutions for the TAI Advanced Technology Production Facility.',
    image: `${BASE_URL}/TAI/tai-b410.jpg`,
    featured: true,
    slug: 'tai-ileri-teknoloji-uretim-tesisi',
    folder: 'TAI',
    gallery: [
      `${BASE_URL}/TAI/tai-b410.jpg`,
    ],
  },
  {
    id: 18,
    title: 'Türkan Saylan Kültür Merkezi',
    title_en: 'Türkan Saylan Cultural Center',
    location: 'İstanbul, Türkiye',
    location_en: 'Istanbul, Türkiye',
    category: 'Kamu & Kültürel',
    tag: 'Kültür Merkezi',
    tag_en: 'Cultural Center',
    year: '2007',
    client: 'Atlas İnşaat',
    client_en: 'Atlas Construction',
    description: 'Türkan Saylan Kültür Merkezi genel aydınlatma projesi kapsamında mimariye uyumlu aydınlatma uygulamaları.',
    description_en: 'Architecturally integrated lighting applications delivered within the scope of the general lighting project for Türkan Saylan Cultural Center.',
    image: `${BASE_URL}/TURKAN-SAYLAN-KULTUR/turkan-saylan.jpg`,
    featured: true,
    slug: 'turkan-saylan-kultur-merkezi',
    folder: 'TURKAN-SAYLAN-KULTUR',
    gallery: [
      `${BASE_URL}/TURKAN-SAYLAN-KULTUR/turkan-saylan.jpg`,
    ],
  },
  {
    id: 19,
    title: 'Yasin Tekstil Fabrikası',
    title_en: 'Yasin Textile Factory',
    location: 'Sivas, Türkiye',
    location_en: 'Sivas, Türkiye',
    category: 'Endüstriyel & Kurumsal',
    tag: 'Tekstil',
    tag_en: 'Textile',
    year: '2024',
    client: 'Yasin Tekstil',
    client_en: 'Yasin Textile',
    description: 'Yasin Tekstil fabrikası için üretim alanlarının tamamını kapsayan endüstriyel aydınlatma projesi.',
    description_en: 'Industrial lighting project covering all production areas for the Yasin Textile factory.',
    image: `${BASE_URL}/YASIN-TEKSTIL/yasin-tekstil.jpg`,
    featured: true,
    slug: 'yasin-tekstil-fabrikasi',
    folder: 'YASIN-TEKSTIL',
    gallery: [
      `${BASE_URL}/YASIN-TEKSTIL/yasin-tekstil.jpg`,
    ],
  },
  {
    id: 20,
    title: 'Aselsan Akyurt Tesisi',
    title_en: 'Aselsan Akyurt Facility',
    location: 'Ankara, Türkiye',
    location_en: 'Ankara, Türkiye',
    category: 'Endüstriyel & Kurumsal',
    tag: 'Savunma Sanayi',
    tag_en: 'Defense Industry',
    year: '2012',
    client: 'Aselsan',
    client_en: 'Aselsan',
    description: 'Aselsan Akyurt Tesisi için yüksek verimlilik odaklı genel aydınlatma çözümleri.',
    description_en: 'High-efficiency general lighting solutions for the Aselsan Akyurt Facility.',
    image: `${BASE_URL}/ASELSAN/aselsan-akyurt.jpg`,
    featured: true,
    slug: 'aselsan-akyurt-tesisi',
    folder: 'ASELSAN',
    gallery: [
      `${BASE_URL}/ASELSAN/aselsan-akyurt.jpg`,
    ],
  },
  {
    id: 21,
    title: 'Kent Etiler',
    title_en: 'Kent Etiler',
    location: 'İstanbul, Türkiye',
    location_en: 'Istanbul, Türkiye',
    category: 'Konut & Rezidans',
    tag: 'Rezidans',
    tag_en: 'Residence',
    year: '2025',
    client: 'Mesa & Asl İnşaat',
    client_en: 'Mesa & Asl Construction',
    description: 'Kent Etiler projesi için 55.000 adet aydınlatma armatürünün dizaynı, üretimi ve projeye uygun teslimi gerçekleştirilmiştir.',
    description_en: 'Design, manufacturing, and project-compliant delivery of 55,000 lighting fixtures for the Kent Etiler project.',
    image: `${BASE_URL}/KENT-ETILER/kent-etiler.jpg`,
    featured: true,
    slug: 'kent-etiler',
    folder: 'KENT-ETILER',
    gallery: [
      `${BASE_URL}/KENT-ETILER/kent-etiler.jpg`,
    ],
  },
  {
    id: 22,
    title: 'Tersane İstanbul',
    title_en: 'Tersane Istanbul',
    location: 'İstanbul, Türkiye',
    location_en: 'Istanbul, Türkiye',
    category: 'Konut & Rezidans',
    tag: 'Karma Kullanım',
    tag_en: 'Mixed-Use',
    year: '2021',
    client: 'Sembol İnşaat',
    client_en: 'Sembol Construction',
    description: 'Tersane İstanbul projesi için kapsamlı aydınlatma ve LED ürün çözümleri.',
    description_en: 'Comprehensive lighting and LED product solutions for the Tersane Istanbul project.',
    image: `${BASE_URL}/TERSANE-ISTANBUL/tersane-istanbul.jpg`,
    featured: true,
    slug: 'tersane-istanbul',
    folder: 'TERSANE-ISTANBUL',
    gallery: [
      `${BASE_URL}/TERSANE-ISTANBUL/tersane-istanbul.jpg`,
    ],
  },
  {
    id: 23,
    title: 'Pulkovo Havalimanı',
    title_en: 'Pulkovo Airport',
    location: 'Rusya',
    location_en: 'Russia',
    category: 'Altyapı & Ulaşım',
    tag: 'Uluslararası',
    tag_en: 'International',
    year: '2011',
    client: 'İçtaş İnşaat',
    client_en: 'İçtaş Construction',
    description: 'Pulkovo Havalimanı projesi için kapsamlı LED aydınlatma çözümleri.',
    description_en: 'Comprehensive LED lighting solutions for the Pulkovo Airport project.',
    image: `${BASE_URL}/PULKOVA-AIRPORT/pulkovo-airport.jpg`,
    featured: true,
    slug: 'pulkovo-airport',
    folder: 'PULKOVA-AIRPORT',
    gallery: [
      `${BASE_URL}/PULKOVA-AIRPORT/pulkovo-airport.jpg`,
    ],
  },
  {
    id: 24,
    title: 'Abdi İbrahim İlaç Fabrikası',
    title_en: 'Abdi İbrahim Pharmaceutical Factory',
    location: 'İstanbul, Türkiye',
    location_en: 'Istanbul, Türkiye',
    category: 'Endüstriyel & Kurumsal',
    tag: 'İlaç',
    tag_en: 'Pharmaceutical',
    year: '2008',
    client: 'Abdi İbrahim',
    client_en: 'Abdi İbrahim',
    description: 'Abdi İbrahim İlaç Fabrikası\'nın tüm aydınlatma çözümleri.',
    description_en: 'Complete lighting solutions for the Abdi İbrahim Pharmaceutical Factory.',
    image: `${BASE_URL}/ABDI-IBRAHIM/abdi-ibrahim.jpg`,
    featured: false,
    slug: 'abdi-ibrahim-ilac-fabrikasi',
    folder: 'ABDI-IBRAHIM',
    gallery: [
      `${BASE_URL}/ABDI-IBRAHIM/abdi-ibrahim.jpg`,
    ],
  },
];

export const featuredProjects: Project[] = allProjects.slice(0, 6);

export const categories = [
  'Tümü',
  'Otel & Konaklama',
  'Ticari & AVM',
  'Altyapı & Ulaşım',
  'Spor & Eğlence',
  'Konut & Rezidans',
  'Kamu & Kültürel',
  'Endüstriyel & Kurumsal',
  'Kurumsal & Ticari',
];

export function getProjectBySlug(slug: string): Project | undefined {
  return allProjects.find((p) => p.slug === slug);
}